<template lang="jade">
  .container-fluid
    .row
      .system_main.col-md-12
        header.system_title_bar.main_title_bar.clearfix
          h1.title.col-md-10.col-sm-10.col-xs-12 system
          span.deviceTime.col-md-3.pull-right.no_pad(v-if="$route.name === 'power'")
              |{{deviceTime}}
        section.maintenance_section.col-md-12.col-sm-12.col-xs-12.row_space--xs.no_pad-xs
          h2.title_bar maintenance
          .btn_group.col-md-12.col-sm-12.col-centered
            h3(v-if='!capability.system.default && !capability.system.upgrade && !capability.system.reboot && !capability.system.rollback')
             | This device does't support any of the maintenance options
            .clearfix.col-lg-3.col-md-3.col-sm-6.col-xs-12(v-show="capability.system.upgrade")
              button.btn.upload.col-md-12.col-xs-12(
                v-on:click="handleMaintenance")
                i.fa.fa-cloud-upload
                | update firmware
            .clearfix.col-lg-3.col-md-3.col-sm-6.col-xs-12(v-show="capability.system.default")
              button.btn.factory_default.col-md-12.col-xs-12(
                v-on:click="resetToFactoryDefault")
                i.fa.fa-gear
                | factory default
            .clearfix.col-lg-3.col-md-3.col-sm-6.col-xs-12(v-show="capability.system.reboot")
              button.btn.reboot.col-md-12.col-xs-12(
                v-on:click="reboot")
                i.fa.fa-rotate-left
                | reboot
            .clearfix.col-lg-3.col-md-3.col-sm-6.col-xs-12(v-show="capability.system.rollback")
              button.btn.rollback.col-md-12.col-xs-12(
                v-on:click="rollbackFirmware")
                i.fa.fa-level-down
                | RollBack
        //- section.alarm_section.col-md-12.col-sm-12.col-xs-12.row_space--xs.no_pad-xs
          h2.title_bar alarm
          .btn_group.col-md-12.col-sm-12
            .btn__single.col-md-12.col-sm-12.col-xs-12.row_space--xxs.no_pad-xs
              label.alarm_label.col-md-1.col-sm-2.col-xs-2.no_pad-xs LED
              button-group.col-md-7.col-sm-7.col-xs-10(type='primary')
                radio(value="on") ON
                radio(value='off') OFF
                radio(value='blinking') Blinking
            .btn__single.col-md-12.col-sm-12.col-xs-12.row_space--xxs.no_pad-xs
              label.alarm_label.col-md-1.col-sm-2.col-xs-2.no_pad-xs Sound
              button-group.col-md-7.col-sm-7.col-xs-10(type='primary')
                radio(value="on") ON
                radio(value='off') OFF
                radio(value='blinking') Blinking
        //- section.temp_dect_section.col-md-12.col-sm-12.col-xs-12.row_space--xs.no_pad-xs
          h2.title_bar Temperature Detection
        modal.confirm_modal(
        title="Confirm"
        v-bind:show.sync="showConfirm"
        effect= "zoom"
        v-bind:callback='confirmCb'
        ok-text="Yes"
        cancel-text="Cancel")
          .modal-body(slot='modal-body').clearfix
            span {{ confirmMsg }}
</template>
<script>
// '
import { call, hasNewFirmware } from 'src/Service'
import { modal, buttonGroup, radio } from 'vue-strap'
import _ from 'lodash'
import moment from 'moment'
const DEVICE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss'

export default {
  components: {
    modal,
    radio,
    'button-group': buttonGroup
  },
  data () {
    return {
      firmware_version: '',
      capability: {},
      showConfirm: false,
      confirmMsg: '',
      confirmCb: function () {},
      timezone: {},
      currentTime: ''
    }
  },
  asyncData () {
    let { mac } = this.$route.params
    if (this.$route.name === 'power') {
      call(mac, 'dxGetTimeZone').then(({timezone}) => {
        this.timezone = timezone
        this.updateTime()
      })
    }
    call(mac, 'dxGetAbout').then(({capability, firmware, model}) => {
      this.capability = _.cloneDeep(capability)
      this.firmware_version = firmware
      console.log(this.capability)
      console.log(this.firmware_version)
      this.$dispatch('updateIsSwitcher', model.toUpperCase().includes('SW'))
    })
  },
  computed: {
    deviceTime () {
      if (this.timezone.useDaylight && moment().isDST()) {
        return moment(this.currentTime).utc().add(this.timezone.offset, 'seconds').add(this.timezone.dstSavings, 'seconds').format(DEVICE_TIME_FORMAT)
      } else {
        return moment(this.currentTime).utc().add(this.timezone.offset, 'seconds').format(DEVICE_TIME_FORMAT)
      }
    }
  },
  methods: {
    updateTime () {
      this.currentTime = Date.now()
      let vue = this
      setTimeout(function () {
        vue.updateTime()
      }, 1000)
    },
    handleMaintenance () {
      hasNewFirmware({
        mac: this.$route.params.mac,
        version: this.firmware_version
      })
      .then(newV => {
        if (newV) {
          this.handleConfirmModal(`Your device is on firmware ${this.firmware_version} Do you want to update to ${newV}?`, () => {
            call(this.$route.params.mac, 'dxUpdateFirmware', {url: newV})
          })
        } else {
          this.handleConfirmModal('Your device firmware is the lastest .')
        }
      })
    },
    rollbackFirmware () {
      this.handleConfirmModal('Are you sure you want to rollback?', () => {
        call(this.$route.params.mac, 'dxRollbackDevice', {})
      })
    },
    resetToFactoryDefault () {
      this.handleConfirmModal('Do you want to reset the device to factory default?', () => {
        call(this.$route.params.mac, 'dxDefaultDevice', {})
        .then((resolved) => {
          console.log('resolved: ', resolved)
        }, (rejected) => {
          console.log('in rejected')
          this.alert('danger', 'Error resetting to factory default', rejected)
        })
      })
    },
    reboot () {
      this.handleConfirmModal('Do you want to reboot the device?', () => {
        call(this.$route.params.mac, 'dxResetDevice', {})
        .then((resolved) => {
          console.log(resolved)
        }, (rejected) => {
          this.alert('danger', 'Error in reboot', rejected)
        })
      })
    },
    handleConfirmModal (msg, callback) {
      console.log('in handleConfim')
      let confirmCb = () => {
        callback()
        this.showConfirm = false
      }
      this.confirmMsg = msg
      this.confirmCb = confirmCb
      this.showConfirm = true
    }
  }, // close methods
  ready () {
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
@import '~__vendor_variables_scss__';
@import '~sass/_breakpoint.scss';
.btn_group{
  & .btn{
    float: left;
    margin-right: 15px;
    margin-top: 15px;
    color:$base_white;
    padding:10px 20px;
    text-transform:capitalize;
    font-size: 16px;
    &.upload{
      background-color:#43c0df;
    }
    &.factory_default{
      background-color:$pri_green;
    }
    &.reboot{
      background-color:$pri_red;
    }
    &.rollback{
      background-color:rgba(25,68,97,.8);
    }
  }
  & i.fa{
    margin-right: 5px;
  }
}
.title_bar{
  border-bottom: 1px solid #ddd;
}
.alarm_label{
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// System.vue?7d13ceb6